module.exports = __webpack_public_path__ + "img/3img_page-0001.fa02a595.jpg";